import * as React from "react";
import { Card } from "antd";
import { CardTitle } from "../../../components/antd/card/CardTitle";
import { CardContent } from "../../../components/antd/card/CardContent";
import { CloudAccountCloudProviderOptions } from "../utils";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpInputDescription } from "../../gvc/testNewForm/CpInputDescription";
import { CpErrorWarningArrayIcon } from "../../gvc/testNewForm/CpErrorWarningArrayIcon";
import { CpLabelTooltip } from "../../gvc/testNewForm/CpLabelTooltip";
import { CpTooltip } from "../../gvc/testNewForm/CpTooltip";
import { CpRadioCardGroup } from "../../gvc/testNewForm/CpRadioCardGroup";

export const General: React.FC = () => {
  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>
            Cloud Account
            <CpErrorWarningArrayIcon names={["name", "description"]} />
          </CardTitle>
          <CardContent>
            <CpFormItem>
              <CpLabelTooltip>
                <CpLabel name={`name`}>Name</CpLabel>
                <CpTooltip tooltipProps={{ title: "Cannot be changed after creation (ok, my-item, item1)" }} />
              </CpLabelTooltip>
              <CpInput name={`name`} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={`name`} />
            </CpFormItem>
            <CpInputDescription namePath="name" descriptionPath="description" />
            <CpFormItem>
              <CpLabel name={"provider"}>Cloud Provider</CpLabel>
              <CpRadioCardGroup
                name={"provider"}
                options={CloudAccountCloudProviderOptions.map((opt) => ({ ...opt, children: "" }))}
              />
              <CpErrorWarning name={"provider"} />
            </CpFormItem>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
